// extracted by mini-css-extract-plugin
export default {"center":"zpT6t","left":"_0UIsZ","right":"oHysv","justifyContentCenter":"olidp","justifyContentLeft":"_6SxI8","justifyContentRight":"xL2HO"};